export const inputClassName =
  "mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm";
export const labelClassName = "block text-sm font-medium text-gray-700";
export const inputErrorClassName = "mt-1 text-sm text-red-600";
